<template>
  <div>
    <div class="yCenter font-weight-bold">
      <NormalButton
        class="mx-2"
        :text="$t('sale.sale_sale-payment-operate')"
        height="32px"
        @click="submit()"
      />

      <NormalButton
        class="mr-2"
        :text="$t('sale.sale_ship-operate')"
        height="32px"
        @click="submit()"
      />

      <NormalButton
        class="mr-2"
        :text="$t('sale.sale_sale-operation')"
        height="32px"
        @click="complete.dialog.dialog = true"
      />

      <NormalButton
        :text="$t('sale.sale_invoice')"
        height="32px"
        width="15px"
        color="white"
        textColor="thinText--text"
        :outlined="true"
        @click="submit()"
      />

      <CompleteDialog
        v-model="complete"
        @complete="completeMethod"
        title="aaaaaaaaaaa"
      />
    </div>
  </div>
</template>
<script>
import NormalButton from '@/components/items/Buttons/NormalButton'

import {
  CompleteDialog
  // StatusHistoryDialog
} from '@/components/layouts/Dialogs'

export default {
  components: {
    NormalButton,
    CompleteDialog
  },
  props: {},
  data: () => ({
    statusHistoryDialog: false,
    complete: {
      dialog: {
        dialog: false,
        data: {
          id: '',
          date: ''
        }
      }
    }
  }),
  methods: {
    getWidth(value) {
      const obj = this.headers.find((ele) => ele.value === value)
      return obj ? obj.width : '100px'
    },
    getCustomerrName(id) {
      return id
    },
    getUserName(id) {
      return id
    },
    getAmount(id) {
      return this.items.productMoves.reduce(
        (accumulator, currentValue, currentIndex, array) => {
          const count = currentValue.quantity * currentValue.price
          return accumulator + count
        },
        0
      )
    },

    completeMethod() {
      alert(this.$t('sale.sale_completion-date') + this.complete.dialog.date)
      // ここに登録処理
      // ...

      this.complete.dialog.dialog = false
    }
  },
  computed: {}
}
</script>
<style lang="scss" scoped>
.btnStyle {
  max-width: 105px;
  padding: 0px !important;
}
</style>
